import React from "react";

import BrainIcon from "@/assets/images/provider/brain.svg?component";
import { DashboardCard2 } from "@/components/layout/DashboardCard2";
import { Link2 } from "@/ui2/atoms/Link";
import OvalIcon from "@/assets/images/provider/Oval.svg?component";
import { providerRoute as provider } from "@/config/roles";

type PatientsCardProps = {
  isUserPCP: boolean;
  patientCount: number;
};

export function PatientsCard({ isUserPCP, patientCount }: PatientsCardProps) {
  return (
    <DashboardCard2 className="tw:justify-between tw:lg:min-h-50" rawChildren>
      <div className="tw:flex tw:items-center tw:justify-between">
        <p className="tw:mb-0 tw:text-3xl tw:font-bold tw:xl:text-5xl">{patientCount}</p>

        <BrainIcon className="tw:hidden tw:size-19.25 tw:md:block" />

        {isUserPCP && (
          <Link2 className="tw:block tw:md:hidden" href={provider + "/patient/add"}>
            <OvalIcon />
          </Link2>
        )}
      </div>

      <div className="tw:flex tw:items-center tw:justify-between">
        <p className="tw:text-sm tw:lg:text-xl">Number of Patients in Platform</p>

        {isUserPCP && (
          <Link2 className="tw:hidden tw:md:block" href={provider + "/patient/add"} rawChildren>
            <OvalIcon />
          </Link2>
        )}
      </div>
    </DashboardCard2>
  );
}
